module.exports = __webpack_public_path__ + "img/meat.9beaec03.svg";